import React, { useState } from 'react';
import { Modal, Form, InputNumber } from 'antd';

interface Props {
  open: boolean;
  onClose: () => void;
  /** 연장 API 완료까지 기다리면 Modal OK 로딩/중복 클릭 방지에 도움이 됩니다. */
  onSubmit: (days: number) => void | Promise<unknown>;
}

const SlotExtendModal: React.FC<Props> = ({ open, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = async () => {
    let days: number;
    try {
      ({ days } = await form.validateFields());
    } catch {
      return;
    }
    setConfirmLoading(true);
    try {
      await Promise.resolve(onSubmit(days));
      form.resetFields();
      onClose();
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="연장 기간 입력"
      okText="연장"
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      destroyOnClose
      width={420}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="days"
          label="연장 일수"
          rules={[{ required: true, type: 'number', min: 1 }]}
        >
          <InputNumber />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SlotExtendModal;
